import { render, staticRenderFns } from "./introduction.vue?vue&type=template&id=2d68369a&scoped=true&"
import script from "./introduction.vue?vue&type=script&lang=js&"
export * from "./introduction.vue?vue&type=script&lang=js&"
import style0 from "./introduction.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./introduction.vue?vue&type=style&index=1&id=2d68369a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d68369a",
  null
  
)

export default component.exports